import React, { useContext } from "react";
import "./SlipDownloadeTemplateCss.css";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { inWords } from "../../utils/helper";
import OrgContext from "../../context/OrgContext/OrgContext";
import moment from "moment";
import html2pdf from "html2pdf-jspdf2";
import { useNavigate } from "react-router";
import { classes } from "../../data/layouts";
import { BANK_TYPE, SLIP_DOWNLOADE } from "../../constant";

const SlipDownloadeTemplate = (props) => {
  const { slipData, model, setModel } = useContext(OrgContext);
  const history = useNavigate();
  const defaultLayoutObj = classes.find(
    (item) => Object.values(item).pop(1) === "compact-wrapper"
  );
  const layout =
    localStorage.getItem("layout") || Object.keys(defaultLayoutObj).pop();

  let amount = 0;

  const handleClose = () => {
    setModel(!model);
  };

  const Print = () => {
    const invoice = document.getElementById("invoice");
    if (!invoice) return;

    // Get exact rendered pixel dimensions of the receipt
    const rect = invoice.getBoundingClientRect();
    const widthPx = rect.width || invoice.offsetWidth || 730;
    const heightPx = rect.offsetHeight || invoice.offsetHeight || rect.height || 380;

    // Convert px to mm (1 px ≈ 0.264583 mm) and add symmetric margins (+4mm width, +6mm height)
    const widthMm = (widthPx * 0.264583) + 4;
    const heightMm = (heightPx * 0.264583) + 6;

    const personName =
      slipData?.transactionDetails?.[0]?.accountTransactionDetail?.personDetail?.name ||
      "slip";
    const fileName = `${personName}-(${slipData?.slipNo || "receipt"}).pdf`;

    const options = {
      margin: [3, 3, 3, 3],
      filename: fileName,
      image: { type: "jpeg", quality: 1.0 },
      html2canvas: {
        scale: 4,
        dpi: 300,
        useCORS: true,
        allowTaint: true,
        letterRendering: true,
        logging: false,
        scrollX: 0,
        scrollY: 0
      },
      jsPDF: {
        unit: "mm",
        format: [widthMm, heightMm],
        orientation: widthMm > heightMm ? "landscape" : "portrait",
        compress: true
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] }
    };

    html2pdf().set(options).from(invoice).save();
    setModel(!model);
    history(`/Donation/income/${layout}`);
  };

  return (
    <>
      <Modal size="lg" isOpen={model} toggle={() => handleClose()}>
        <ModalHeader toggle={() => handleClose()}></ModalHeader>
        <ModalBody>
          {slipData?.htmlContent ? (
            <div>
              <style>{`
                #invoice, #invoice * {
                  zoom: 1 !important;
                  -webkit-font-smoothing: antialiased !important;
                  -moz-osx-font-smoothing: grayscale !important;
                  text-rendering: optimizeLegibility !important;
                }
                #invoice .main-div {
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                  margin-top: 0px !important;
                  margin-bottom: 0px !important;
                }
                #invoice .second-div {
                  margin-top: 0px !important;
                  margin-bottom: 0px !important;
                }
                #invoice .thard-div {
                  margin-top: 0px !important;
                  margin-bottom: 0px !important;
                }
                #invoice .fourth-div {
                  padding-top: 0px !important;
                  margin-top: 0px !important;
                }
                #invoice [style*="grayscale"] img,
                #invoice [style*="opacity"] img {
                  filter: grayscale(100%) opacity(0.3) !important;
                  -webkit-filter: grayscale(100%) opacity(0.3) !important;
                }
              `}</style>
              <div
                id="invoice"
                style={{
                  padding: "0px",
                  margin: "0px",
                  background: "#ffffff",
                  width: "100%",
                  boxSizing: "border-box"
                }}
                dangerouslySetInnerHTML={{ __html: slipData.htmlContent }}
              />
            </div>
          ) : slipData ? (
            <div>
              <div className="main-div">
                {/* <div className="second-div" id="invoice"> */}
                {/* <div className="second-div" id="printablediv"> */}
                <div className="second-div" id="invoice">
                  <div className="thard-div ">
                    {/* <!-- Main Heading Html And Css --> */}

                    <div className="fourth-div">
                      <p>श्री स्वामिनारायणो विजयतेतराम्</p>
                    </div>

                    {/* <!-- Second Header and names html and css --> */}

                    <div className="main-perent">
                      <div className="main_content">
                        <p>
                          <h5>
                            {slipData.temple.templeName
                              ? slipData.temple.templeName
                              : "--"}
                          </h5>
                        </p>
                        <p className="main-content_p-tag">
                          {slipData.trust.trustName
                            ? slipData.trust.trustName
                            : "--"}
                        </p>
                        <p className="main-content_p-tag">
                          {SLIP_DOWNLOADE.MOBILE}:{" "}
                          {slipData.temple.mobile
                            ? slipData.temple.mobile
                            : "--"}
                          | {SLIP_DOWNLOADE.EMAIL}:{" "}
                          {slipData.temple.email ? slipData.temple.email : "--"}
                        </p>
                        <p className="main-content_p-tag">
                          {SLIP_DOWNLOADE.TRUST_REG}:{" "}
                          {slipData.trust.trustRegNo
                            ? slipData.trust.trustRegNo
                            : ""}
                          | {SLIP_DOWNLOADE.PAN_NO}:
                          {slipData.trust.panNo ? slipData.trust.panNo : "--"} |{" "}
                          {SLIP_DOWNLOADE.CERTI_NO}:
                          {slipData.trust.certNo ? slipData.trust.certNo : "--"}
                        </p>
                      </div>
                    </div>

                    {/* <!-- Table Slip Html and Css --> */}
                    <div className="content-div">
                      <div style={{ margin: " 12px 12px 12px 12px" }}>
                        <table className="tabel">
                          {/* <!-- Table Head --> */}
                          <tr>
                            <td
                              className="border-none p-t p-l tabel-Head-title"
                              // colSpan={2}
                            >
                              {SLIP_DOWNLOADE.NAME}
                            </td>
                            <td
                              className="border-none font-bold p-t p-l font-sizing "
                              colSpan="2"
                            >
                              {slipData.transactionDetails[0]
                                .accountTransactionDetail.personDetail
                                ? slipData.transactionDetails[0]
                                    .accountTransactionDetail.personDetail.name
                                : "--"}
                            </td>
                          </tr>
                          {/* <tr>
                            <td className="border-none tabel-Head-title ">
                              {SLIP_DOWNLOADE.RECEIPT_NO}
                            </td>
                            <td className="border-none font-bold font-sizing">
                              :{slipData.slipNo}
                            </td>
                          </tr> */}
                          <tr>
                            <td className="border-none p-t p-l tabel-Head-title">
                              {SLIP_DOWNLOADE.MOBILE_NO}
                            </td>
                            <td
                              className="border-none font-bold p-t p-l font-sizing"
                              colSpan="2"
                            >
                              {`: ${
                                (() => {
                                  const person = slipData?.transactionDetails[0]?.accountTransactionDetail?.personDetail;
                                  if (person && person.mobile && person.mobile.trim() && person.mobile.trim() !== 'null' && person.mobile.trim() !== 'undefined' && person.mobile.trim().length >= 10) {
                                    return person.mobile.trim();
                                  } else if (person && person.kinMobile && person.kinMobile.trim() && person.kinMobile.trim() !== 'null' && person.kinMobile.trim() !== 'undefined' && person.kinMobile.trim().length >= 10) {
                                    return person.kinMobile.trim();
                                  }
                                  return "--";
                                })()
                              }`}
                            </td>

                            <td
                              className="border-none tabel-Head-title"
                              style={{ width: "9rem" }}
                            >
                              {SLIP_DOWNLOADE.RECEIPT_DATE}
                            </td>
                            <td
                              className="border-none font-bold font-sizing"
                              style={{ width: "9rem" }}
                            >
                              {`: ${
                                slipData.createdAt
                                  ? moment(slipData.createdAt).format(
                                      "DD MMM, YYYY"
                                    )
                                  : "--"
                              }`}
                            </td>
                          </tr>

                          <tr>
                            <td className="border-none p-t p-l p-b tabel-Head-title">
                              {SLIP_DOWNLOADE.PAN_NO}
                            </td>
                            <td
                              className="border-none font-bold p-t p-l p-b font-sizing"
                              colSpan="2"
                            >
                              {`: ${
                                slipData.transactionDetails[0]
                                  .accountTransactionDetail.personDetail
                                  ? slipData.transactionDetails[0]
                                      .accountTransactionDetail.personDetail
                                      .panCardNo
                                  : "--"
                              }`}
                            </td>

                            <td className="border-none tabel-Head-title ">
                              {SLIP_DOWNLOADE.RECEIPT_NO}
                            </td>
                            <td className="border-none font-bold font-sizing">
                              : {slipData.slipNo}
                            </td>
                          </tr>
                          <tr>
                            <td className="border-none p-t p-l tabel-Head-title">
                              {SLIP_DOWNLOADE.ADDRESS}
                            </td>

                            <td
                              className="border-none font-bold p-t p-l font-sizing"
                              colSpan="4"
                            >
                              {`: ${
                                slipData.transactionDetails[0]
                                  .accountTransactionDetail.personDetail
                                  ? slipData.transactionDetails[0]
                                      .accountTransactionDetail.personDetail
                                      .village
                                  : "--"
                              }`}
                            </td>
                          </tr>

                          {/* <!-- Table Body --> */}

                          <tr>
                            <td
                              colSpan="4"
                              className="text-center font-bold  p-b letter-spacing td font-sizing"
                              style={{ paddingTop: "0.5rem" }}
                            >
                              {SLIP_DOWNLOADE.PURPOSE}
                            </td>
                            <td
                              className="text-right font-bold p-b letter-spacing p-r td font-sizing"
                              style={{ paddingTop: "0.5rem" }}
                            >
                              {SLIP_DOWNLOADE.AMOUNT}
                            </td>
                          </tr>
                          {slipData.transactionDetails.map((elem) => {
                            amount += elem.amount;
                            return (
                              <tr>
                                <td
                                  colSpan="4"
                                  className="p-l p-b font-bold letter-spacing font-sizing td "
                                  style={{ paddingTop: "0.5rem" }}
                                >
                                  {elem.accountTransactionDetail
                                    ? elem.accountTransactionDetail
                                        .AccountDetail.name
                                    : "--"}
                                </td>
                                <td className="text-right p-r font-bold font-sizing td">
                                  {elem.amount ? elem.amount : "--"}
                                </td>
                              </tr>
                            );
                          })}
                          <tr>
                            <td
                              className="border-none p-l p-b letter-spacing td font-sizing"
                              style={{
                                fontWeight: "bold",
                                color: "black",
                                paddingTop: "0.5rem",
                              }}
                            >
                              Amount In Word
                            </td>
                            <td
                              colSpan="3"
                              className="border-none p-l p-b font-bold letter-spacing font-sizing td"
                              style={{ paddingTop: "0.5rem" }}
                            >
                              :{inWords(amount)}
                            </td>
                            <td
                              className="text-right p-l p-b p-r font-bold font-sizing td"
                              style={{ paddingTop: "0.5rem" }}
                            >
                              {amount}
                            </td>
                          </tr>
                          <tr className="text-center">
                            <td
                              className="border-bottom letter-spacing font-sizing td"
                              style={{
                                fontWeight: "bold",
                                color: "black",
                                paddingTop: "0.5rem",
                              }}
                            >
                              Mode
                            </td>
                            <td
                              className="border-bottom letter-spacing font-sizing td"
                              style={{
                                fontWeight: "bold",
                                color: "black",
                                paddingTop: "0.5rem",
                              }}
                            >
                              Cheque/DD No
                            </td>
                            {/* <td
                              className="border-bottom letter-spacing font-sizing td"
                              style={{
                                fontSize: "14px",
                                fontWeight: "bold",
                                color: "gray",
                                paddingTop: "0.5rem",
                              }}
                            >
                              Date
                            </td> */}
                            <td
                              style={{
                                fontWeight: "bold",
                                color: "black",
                                paddingTop: "0.5rem",
                              }}
                              className="border-bottom letter-spacing font-sizing td"
                              colSpan={2}
                            >
                              Bank
                            </td>
                            <td
                              style={{
                                fontWeight: "bold",
                                color: "black",
                                paddingTop: "0.5rem",
                              }}
                              className="border-bottom letter-spacing font-sizing td"
                            >
                              Branch
                            </td>
                          </tr>
                          <tr className="text-center">
                            <td
                              className="border-top letter-spacing font-bold p-b font-sizing td"
                              style={{ paddingTop: "0.5rem" }}
                            >
                              {slipData.transactionDetails[0].bankDetail
                                .type === BANK_TYPE.CASE
                                ? BANK_TYPE.CASE_LABALE
                                : BANK_TYPE.BANK_LABALE}
                            </td>
                            <td
                              className="border-top letter-spacing font-bold p-b font-sizing td"
                              style={{ paddingTop: "0.5rem" }}
                            >
                              {slipData.PaymentType
                                ? slipData.PaymentType
                                : "-"}
                            </td>
                            <td
                              className="border-top letter-spacing font-bold p-b font-sizing td"
                              style={{ paddingTop: "0.5rem" }}
                              colSpan={2}
                            >
                              {slipData.transactionDetails
                                ? slipData.transactionDetails[0].bankDetail.name
                                : "--"}
                            </td>
                            <td
                              className="border-top letter-spacing font-bold p-b font-sizing td"
                              style={{ paddingTop: "0.5rem" }}
                            >
                              {slipData.transactionDetails
                                ? slipData.transactionDetails[0].bankDetail
                                    .branch
                                : "--"}
                            </td>
                          </tr>
                        </table>
                      </div>

                      {/* <!-- Bottom --> */}

                      <div className="bottom-1">
                        <p className="font-sizing">
                          For, Temple{" "}
                          {slipData.temple ? slipData.temple.templeName : ""}
                        </p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          {slipData.transactionDetails &&
                          slipData.transactionDetails[0]
                            .accountTransactionDetail.dueAmount !== 0 ? (
                            <>
                              {" "}
                              <p
                                style={{ color: "#ff0000bf" }}
                                className="font-sizing"
                              >
                                Due Amount :
                                {slipData.transactionDetails
                                  ? slipData.transactionDetails[0]
                                      .accountTransactionDetail.dueAmount
                                  : "--"}{" "}
                              </p>
                            </>
                          ) : (
                            <p style={{ fontSize: "0px" }}>.</p>
                          )}
                          <p className="font-sizing">
                            Received By{" "}
                            {slipData.creator ? slipData.creator.name : ""}
                          </p>
                        </div>
                      </div>
                      <div className="p-l p-b letter-spacing">
                        <p className="font-sizing">
                          (This is Syatem Generated Receipt, it Dose Not Require
                          Signature)
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              paddingTop: "15px",
            }}
          >
            <Button primary={true} onClick={Print}>
              Download
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default SlipDownloadeTemplate;
